export default __webpack_public_path__ + "static/apple-e2176114f1116b7782d99091dee3c73e.svg";